import Form from './Form';
import Alerts from '../Alerts';

export default class SendWelcomeForm extends Form {
    templateId() {
        return '#sendWelcomeTemplate';
    }

    data() {
        return '/dashboard/profile/ajax/sendWelcome/get';
    }

    onSuccess() {
        var alerts = new Alerts(this.loader);
        alerts.load('#alerts');
    }
}
